<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Video qualities</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in video qualities..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('videoQualityKey')">Video quality key</th>
              <th class="col-1" @click="toggleSort('videoQualityValue')">Video quality value</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('updated')">Updated</th>

              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.videoQualityKey">
              <td class="col-1 text-truncate" v-html="truncateText(config.videoQualityKey, 30)" @click="selectText" :data-text="config.videoQualityKey"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.videoQualityValue, 30)" @click="selectText" :data-text="config.videoQualityValue"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 30)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate" v-html="functions.formatUnixTimestamp(config.updated)" @click="selectText" :data-text="config.updated"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'VideoQualityEdit', params: { id: config.videoQualityKey, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import functions from "@/functions";

export default {
  name: "VideoQualities",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      VideoQualityList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
    };
  },
  computed: {
    functions() {
      return functions
    },
    filteredCouponsList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.VideoQualityList.filter((config) => {
        return (
            (config.videoQualityKey && config.videoQualityKey.toString().includes(search)) ||
            (config.videoQualityValue && config.videoQualityValue.toLowerCase().includes(search)) ||
            (config.active && config.active.toString().includes(search)) ||
            (config.application && config.application.toString().includes(search)) ||
            (config.updated && config.updated.toString().includes(search))
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      return filteredList;
    },
    sortData() {
      return this.filteredCouponsList;
    },
  },
  created() {
    this.doLoadPlans();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'videoQualityKey';
  },
  methods: {
    doLoadPlans() {
      AdminService.getVideoQualityList().then((data) => {
        this.VideoQualityList = data;
      }).catch((error) => {
        console.error("Error loading video qualities:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      if (text === undefined || text ===null) {
        return null
      } else {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
    },
    redirectToCreate() {
      this.$router.push({ name: 'VideoQualityCreate' });
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
  },
};
</script>
<style src="../../assets/style.css">
</style>
